export default __webpack_public_path__ + "static/media/pos1.7768bab2.gif";